<template v-if="listItem">
  <li class="chaton-userbar_loader chaton-inner-loaader">
    <span><i class="chaton-spinericon"></i></span>
  </li>
</template>

<script>
  export default {
    name : "ChatInnerLoader",
  }
</script> 

<style>
.chaton-userbar_loader.chaton-inner-loaader,
.chaton-inner-loaader{
  height: 134px;
  bottom: 60px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 59.37%);
  }
.chaton-inner-loaader span{
  height: 64px;
}
.chaton-inner-loaader i{
  width: 24px;
  height: 24px;
  border: 3px solid #ddd;
  border-right-color: #fff;
  border-radius: 50px 50px 50px 50px;
  animation: spinericon 1s linear infinite;
}
.chaton-whatsappchatfloat .chaton-inner-loaader {
  bottom: 0;
}
.chaton-userlist_tab li.chaton-inner-loaader {
  width: calc(100% - 5px) !important;
}
</style>